import logoSanef from "../../images/logo.png";
import {TextField} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faSignInAlt} from "@fortawesome/free-solid-svg-icons";
import Footer from "../../components/Layout/Footer";
import MyDialog from "../../components/Layout/MyDialog";
import React, {useState} from "react";
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import {useAlert} from "react-alert";

const ForgottenPassword = () => {
	const navigate = useNavigate();
	const alert = useAlert();
	const [email, setEmail] = useState(null);

	const handleChange = (e, pattern) => {
		const regex = new RegExp(pattern);
		if (e.target.value === '' || regex.test(e.target.value)) {
			setEmail(e.target.value);
		}
	}

	const handleSubmit = () => {
		axios({ method: 'post', url: URL_API + '/utilisateur/mot-de-passe-oublie', params : { email : email }})
			.then(() => {
				alert.removeAll();
				alert.success("Le mail de réinitilisation a bien été envoyé");
				navigate("/");
			})
			.catch((error) => {
				alert.removeAll();
				alert.error(error?.response?.data?.message || "Une erreur est survenue, merci de contacter un administrateur");
			});
	}

	return (
		<div id="fond">
			<div id="filtre-rose" />

			<div id="card-inscription" style={{height: '40vh'}}>
				<div id="bloc-logo"><img id="logo" alt='' src={logoSanef} /></div>
				<div id="barre-rose" />
				<div className="libelle-form-connexion" id="barre-grise">Transports exceptionnels</div>

				<div id="formulaire-inscription" style={{height: '14vh'}}>
					<div>
						<img className="panneau" alt='' />
						<span className="libelle-form-connexion">Email *</span>
						<TextField
							style={{ marginLeft: '30px', marginTop: '10px' }}
							className="champ"
							onChange={(e) => handleChange(e)}
							name="email"
							autoComplete="off"
							variant="outlined"
							size="small"
							value={email || ''}
							error={email === null || email === ''}
							required
						/>
					</div>
				</div>

				<div id="buttons-actions-connexion">
					<Link to="/" style={{ textDecoration: "none" }}>
						<button id="btn-connexion" type="button">
							<span className="error"><FontAwesomeIcon icon={faSignInAlt} /></span>
							<span className="libelle-form-connexion">Annuler</span>
						</button>
					</Link>
					<button id="btn-inscription" type="submit" onClick={handleSubmit}>
						<span className="error"><FontAwesomeIcon icon={faCheck} /></span>
						<span className="libelle-form-connexion">Envoyer</span>
					</button>
				</div>
			</div>
			<Footer/>
		</div>
	);
}

export default ForgottenPassword;